import React, { Component } from "react";
import { withFormsy } from "formsy-react";
import { AsyncSelect } from "../../Shared/Forms";
import { interestService } from "./services/interest.service";

class InterestDropdown extends Component {
  state = {
    fetching: false,
    fetched: false,
    response: null,
    error: null,
    id: null
  };

  getInterestByName = (inputValue, callback) => {
    this.setState({ fetching: true });
    if (inputValue && inputValue.length > 2) {
      interestService
        .getAllInterest({ name: inputValue })
        .then(response => {
          if (response) {
            this.setState({ response, error: null, fetching: false });

            callback(response.content);
          }
        })

        .catch(error => this.setState({ error, fetching: false }));
    }
  };

  getInstructorName = (inputValue, callback) => {
    this.setState({ fetching: true });
    if (inputValue && inputValue.length > 2) {
      interestService
        .getInstructorInterest({ name: inputValue })
        .then(response => {
          if (response) {
            this.setState({
              response,
              error: null,
              fetching: false,
              id: response.content
            });
            this.props.getInterestId(response);
            callback(response.content);
          }
        })
        .catch(error => this.setState({ error, fetching: false }));
    }
  };

  render() {
    const {
      name,
      disabled,
      value,
      isRequired,
      defaultOptions,
      isMulti,
      instructorInterest,
      title
    } = this.props;

    return (
      <div>
        <AsyncSelect
          isMulti={isMulti}
          name={name}
          value={value}
          defaultOptions={defaultOptions}
          title={title || "Interests"}
          loadOptions={
            !instructorInterest
              ? this.getInterestByName
              : this.getInstructorName
          }
          valueKey="id"
          disabled={disabled}
          labelKey="name"
          validating={disabled}
          innerRef={c => {
            this.interests = c;
          }}
          isClearable={true}
          required={isRequired}
        />
      </div>
    );
  }
}

export default withFormsy(InterestDropdown);
